import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import ForgotPasswordContent from "../../../components/Pages/Auth/ForgotPassword";
import Layout from "../../../components/Layout";
import SimpleLayout from "../../../components/Layout/Simple";

const { displayName } = config;

export default function ForgotPassword(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Forgot password`;
  }, []);

  return (
    <SimpleLayout>
      <ForgotPasswordContent />
    </SimpleLayout>
  );
}
